module.exports = "https://referendum2020-campaigns-cdn.fire-emblem-heroes.com/images/223.e83ecb2d.png";